import axios from "axios";
import { ApiUrl, header } from "../../utils/modules";

class EntrepriseServices {
  getAll() {
    return axios.get(ApiUrl + "entreprise", header());
  }

  getOne(id) {
    return axios.get(ApiUrl + `entreprise/${id}`, header());
  }

  create(data) {
    return axios.post(ApiUrl + "entreprise", data, header());
  }

  update(id, data) {
    return axios.put(ApiUrl + `entreprise/${id}`, data, header());
  }

  delete(id) {
    return axios.delete(ApiUrl + `entreprise/${id}`, header());
  }
}


export default new EntrepriseServices();
